export default "__VITE_ASSET__xltRysMp__"